import React, { useState, useEffect } from 'react'
import { getRelativeBasePath } from '../../../global/environments/path'
import { getUrlParameter } from '../../../global/data/url.js'
import Loader from '../../../components/Loading/Loading.jsx'
import InstitutionalLoginScreen from './InstitutionalLogin.jsx'
import InstitutionalMFA from './common/InstitutionalMFA.jsx'
import InstitutionalMFAnswer from './common/InstitutionalMFAnswer.jsx'
import InstitutionalChangePassword from './common/InstitutionalChangePassword.jsx'
import InstitutionalUserAgreement from './common/InstitutionalUserAgreement.jsx'
import {
  generateUID,
  addTMXScriptToBody,
} from '../../utility/threatMetrix/TMX.js'
import {
  screens,
  accessStorage,
  makeChangePasswordRequest,
  showAlertSuccess,
} from './common/institutionalServiceHelper.js'

function InstitutionalLoginContainter() {
  const [tmxId, setTmxId] = useState()
  const [activeScreen, setActiveScreen] = useState(screens.LOGIN_SCREEN)
  const [screenData, setScreenData] = useState({
    isTempChangePassword: false,
  })
  const [isShowLoader, setShowLoader] = useState(false)

  const screenChangeHandler = (screen, data = {}) => {
    if (screen !== null && screen !== activeScreen) {
      setActiveScreen(screen)
    }
    setScreenData({ ...screenData, ...data })
  }

  const onCancleClick = () => {
    screenChangeHandler(screens.LOGIN_SCREEN, { isTempChangePassword: false })
  }

  const redirectToYourReport = () => {
    window.location.href = getRelativeBasePath() + '/secure/your-reports'
  }

  const onSuccessFullLogin = () => {
    if (screenData?.isTempChangePassword) {
      setActiveScreen(screens.CHANGE_PASSWORD_SCREEN)
    } else {
      accessStorage.setInstitutionalLoggedIn() // make user loggedIn
      redirectToYourReport()
    }
  }

  const onSuccessChangePassword = async (payload, handleError) => {
    setShowLoader(true)
    try {
      const data = await makeChangePasswordRequest(payload, {
        action: 'changeTempPwd',
      })
      if (data && !data.error) {
        if (!accessStorage.getUserAgreement()) {
          setActiveScreen(screens.USER_AGREEMENT_SCREEN)
        } else {
          loginAfterTempPassword()
        }
      } else {
        if (data?.error?.details) {
          handleError(data.error.details.code, data.error.details.message)
        } else {
          handleError(data?.error?.code, data.error.message)
        }
      }
    } catch (error) {
      handleError('ERROR')
    }
    setShowLoader(false)
  }

  const loginAfterTempPassword = () => {
    window.location.href = getRelativeBasePath() + '/login?forgotPassword=true'
  }

  const showPopup = () => {
    if (getUrlParameter('forgotPassword')) {
      showAlertSuccess({
        title: 'You have successfully changed your password.',
        text: 'Use your new password to log in.',
      })
    }

    if (getUrlParameter('timeout')) {
      showAlertSuccess({
        title: ' For your protection, ',
        text: 'we have logged you out of your account. To access your account, please log in again.',
      })
    }

    if (getUrlParameter('logout')) {
      showAlertSuccess({
        title: 'You have successfully logged out. ',
        text: 'Thank you for visiting.',
      })
    }
  }

  const _props = {
    tmxId,
    ...screenData,
    onCancleClick,
    screenChangeHandler,
    setShowLoader,
    onSuccessFullLogin,
  }

  const addTMXScriptToBodyHandler = async () => {
    const tmx_id = `cti_ins_${generateUID()}`
    setTmxId(tmx_id)
    showPopup()
    await addTMXScriptToBody(tmx_id)
  }

  useEffect(() => {
    addTMXScriptToBodyHandler()
  }, [])

  return (
    <>
      {activeScreen === screens.USER_AGREEMENT_SCREEN ? (
        <InstitutionalUserAgreement
          redirectToYourReport={loginAfterTempPassword}
        />
      ) : (
        <>
          <div className="u-sizeConstrained">
            <div className="u-marginTop10gu u-marginBottom4gu">
              <h2 className="u-paddingBottom2gu u-borderBottom u-inlineBlock u-borderBottomColorBrandLighter">
                Log in: Institutional investor
              </h2>
            </div>
          </div>
          <div className="u-posRelative u-bgColorLightest u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0 u-padding8gu u-marginBottom10gu">
            {isShowLoader && <Loader />}
            {activeScreen === screens.LOGIN_SCREEN && (
              <InstitutionalLoginScreen {..._props} />
            )}
            {activeScreen === screens.MFA_SCREEN && (
              <InstitutionalMFA {..._props} />
            )}
            {activeScreen === screens.MFA_ANSWER_SCREEN && (
              <InstitutionalMFAnswer {..._props} />
            )}
            {activeScreen === screens.CHANGE_PASSWORD_SCREEN && (
              <InstitutionalChangePassword
                {..._props}
                onSuccessChangePassword={onSuccessChangePassword}
              />
            )}
          </div>
        </>
      )}
    </>
  )
}

export default InstitutionalLoginContainter
